export const FORM_IDS = {
  CREATE: "create-bank-account-form",
  EDIT: "edit-bank-account-form",
  DELETE: "delete-bank-account-form",
};
